/* Ça Roule : tiroir Rayons de la barre du bas + panneaux des tuiles */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- tiroir ---------- */
  let lastFocus = null;

  function openSheet(sheet) {
    lastFocus = document.activeElement;
    sheet.hidden = false;
    requestAnimationFrame(() => {
      sheet.classList.add('is-open');
      const first = sheet.querySelector('a, button');
      if (first) first.focus({ preventScroll: true });
    });
  }

  function closeSheet(sheet) {
    sheet.classList.remove('is-open');
    window.setTimeout(() => {
      sheet.hidden = true;
    }, reduce ? 0 : 200);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cr-open]');
    if (opener) {
      const sheet = document.getElementById(opener.getAttribute('data-cr-open'));
      if (sheet) {
        event.preventDefault();
        openSheet(sheet);
      }
      return;
    }
    const closer = event.target.closest('[data-cr-close]');
    if (closer) {
      const sheet = closer.closest('.cr-sheet');
      if (sheet) closeSheet(sheet);
    }
  });

  window.CaRoule = { openSheet, closeSheet };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.cr-sheet.is-open').forEach(closeSheet);
  });

  /* ---------- tuiles : le rayon s'ouvre sous les tuiles ---------- */
  function initTiles(root) {
    if (root.dataset.crReady) return;
    root.dataset.crReady = '1';
    root.addEventListener('click', (event) => {
      const tile = event.target.closest('.cr-tile[aria-controls]');
      if (!tile) return;
      const panel = document.getElementById(tile.getAttribute('aria-controls'));
      if (!panel) return;
      event.preventDefault();
      const open = tile.getAttribute('aria-expanded') === 'true';
      root.querySelectorAll('.cr-tile[aria-controls]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
      root.querySelectorAll('.cr-panel').forEach((p) => {
        p.hidden = true;
        p.classList.remove('is-in');
      });
      if (!open) {
        tile.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.classList.add('is-in');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cr-tiles]').forEach(initTiles);
  }

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  /* l'éditeur de thème recharge les sections à la volée */
  document.addEventListener('shopify:section:load', initAll);
})();

/* Rouli : bulle + parcours guidé « Premier skate » */
(() => {
  const buddy = document.getElementById('cr-buddy');
  const guide = document.getElementById('cr-guide');
  const dataEl = document.getElementById('cr-guide-data');
  if (!guide || !dataEl) return;

  let data = { items: {} };
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {}
  const items = data.items || {};
  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  const money = (cents) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(cents / 100);
  const artEl = document.querySelector('.cr-rouli-art');
  const art = artEl ? artEl.outerHTML : '';

  /* ---------- bulle ---------- */
  const say = document.getElementById('cr-say');
  const sayText = document.getElementById('cr-say-text');
  const sayCta = document.getElementById('cr-say-cta');
  let timer = null;
  let muted = false;
  let jokeIndex = 0;
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del(k) { try { sessionStorage.removeItem(k); } catch (e) {} },
  };

  function talk(text, opts = {}) {
    if (!buddy || !text || (muted && !opts.force)) return;
    sayText.textContent = text;
    sayCta.hidden = !opts.cta;
    say.classList.add('is-on');
    window.clearTimeout(timer);
    timer = window.setTimeout(() => say.classList.remove('is-on'), opts.cta ? 6000 : 3800);
  }

  if (buddy) {
    muted = store.get('cr-rouli-off') === '1';
    if (muted) buddy.classList.add('is-off');
    const jokes = (buddy.dataset.jokes || '').split('|').map((s) => s.trim()).filter(Boolean);

    document.getElementById('cr-say-x').addEventListener('click', () => {
      say.classList.remove('is-on');
      muted = true;
      buddy.classList.add('is-off');
      store.set('cr-rouli-off', '1');
    });

    document.getElementById('cr-buddy-av').addEventListener('click', () => {
      if (muted) {
        muted = false;
        buddy.classList.remove('is-off');
        store.del('cr-rouli-off');
        talk("De retour. Tu m'as manqué, un peu.", { force: true });
        return;
      }
      if (jokeIndex === 0 || !jokes.length) {
        jokeIndex++;
        talk('Skate, outfit ou les deux ? Je te compose le combo.', { force: true, cta: true });
        return;
      }
      talk(jokes[(jokeIndex++ - 1) % jokes.length], { force: true });
    });

    window.setTimeout(() => {
      const line = buddy.dataset.line;
      if (line) {
        talk(line);
      } else if (!store.get('cr-rouli-hello')) {
        store.set('cr-rouli-hello', '1');
        talk(buddy.dataset.hello, { cta: true });
      }
    }, 1200);
  }

  /* ---------- le guide de Rouli : skate, outfit, ou les deux ----------
     Rouli demande ce que le client vient chercher (ou le déduit de la page), puis compose un combo
     en stock à la bonne taille. Les produits viennent du flux /collections/all?view=caroule-guide,
     classés par type de produit ; les réglages du thème servent de préférences. */
  const body = document.getElementById('cr-guide-body');
  const RANGE = {
    s: { min: 6.9, max: 7.9, target: 7.4, label: '7" à 7.9"' },
    m: { min: 7.75, max: 8.06, target: 7.9, label: '7.75" à 8"' },
    l: { min: 8, max: 8.38, target: 8.2, label: '8" à 8.25"' },
    xl: { min: 8.25, max: 8.6, target: 8.45, label: '8.25" à 8.5"' },
  };
  const ROLE = {
    deck: 'La planche, à ta largeur',
    complete: 'Planche, trucks, roues et grip : déjà monté',
    cruiser: 'Grandes roues souples : confort en ville',
    kit: 'Pack trucks + roues + roulements + visserie : tout le dessous de la planche',
    trucks: 'Les essieux qui tiennent les roues et font tourner',
    wheels: 'Roues dures et petites : idéales en skatepark',
    bearings: 'Dans les roues, pour que ça glisse',
    hardware: 'Les 8 vis qui fixent les trucks à la planche',
    grip: 'Le dessus qui accroche les pieds',
    helmet: 'Indispensable pour débuter',
    pads: 'Genoux, coudes, poignets',
    top: 'Le haut',
    bottom: 'Le bas',
    cap: 'Sur la tête',
    shoes: 'Aux pieds',
  };
  const BOTTOM = { XS: ['XS', '26', '27'], S: ['S', '28', '29'], M: ['M', '30', '31'], L: ['L', '32', '33'], XL: ['XL', '34', '35', '36'] };
  const TOPSUB = [['tee', 'T-shirt'], ['sweat', 'Sweat'], ['jacket', 'Veste']];
  const CAPSUB = [['tee', 'Casquette'], ['beanie', 'Bonnet']];
  let G = {};
  let hist = [];
  let R = {};
  let feed = null;
  let feedPromise = null;

  const num = (s) => parseFloat(String(s).replace(',', '.'));
  const first = (s) => { const m = String(s).match(/\d+(?:[.,]\d+)?/); return m ? num(m[0]) : null; };
  const sizeTok = (v) => String(v[1]).split(' / ')[0].trim().toUpperCase().replace(/^2\s?XL$/, 'XXL');
  const skateRange = () => (G.shoe <= 35 ? 's' : G.shoe <= 39 ? 'm' : G.shoe <= 43 ? 'l' : 'xl');
  const wants = (x) => G.goal === x || G.goal === 'both';
  const kidMode = () => G.who === 'kid';

  function widthOf(item, v) {
    const vt = String(v[1]);
    if (/^\s*\d+([.,]\d+)?\s*"?\s*$/.test(vt)) return num(vt);
    if (/mini/i.test(vt)) return 7;
    const m = item.t.match(/(\d+(?:[.,]\d+)?)\s*["″”]/);
    return m ? num(m[1]) : null;
  }

  function loadFeed() {
    if (feedPromise) return feedPromise;
    const url = (p) => data.feed + '&page=' + p;
    feedPromise = fetch(url(1))
      .then((r) => r.json())
      .then(async (one) => {
        let all = one.items || [];
        for (let p = 2; p <= Math.min(one.pages || 1, 4); p++) {
          try {
            const more = await fetch(url(p)).then((r) => r.json());
            all = all.concat(more.items || []);
          } catch (e) {}
        }
        feed = all;
        return all;
      })
      .catch(() => {
        feedPromise = null;
        feed = null;
        return null;
      });
    return feedPromise;
  }

  const prefer = (key) => (items[key] && items[key].h) || null;
  const byKind = (k) => (feed || []).filter((it) => it.k === k && it.vs.some((v) => v[3]));
  const avail = (it) => it.vs.filter((v) => v[3]);
  const sortPref = (list, h) => (h ? list.sort((a, b) => (b.h === h) - (a.h === h)) : list);
  const asLine = (it, v, extra) => ({ t: it.t, img: it.img, h: it.h, v: v[0], c: v[2], vt: v[1], vs: avail(it).length > 1 ? avail(it) : null, ...extra });

  /* planches, complets, cruisers à la bonne largeur, du plus proche au plus loin puis du moins cher */
  function pickWidth(kind, size, kid) {
    const r = RANGE[size];
    const out = [];
    byKind(kind).forEach((it) => {
      if (kind !== 'cruiser' && !kid && it.kid) return;
      avail(it).forEach((v) => {
        const w = widthOf(it, v);
        if (kind !== 'cruiser' && (w == null || w < r.min - 0.01 || w > r.max + 0.01)) return;
        out.push({ it, v, w });
      });
    });
    const seen = new Set();
    return out
      .sort((a, b) => (kid ? b.it.kid - a.it.kid : 0) || Math.abs((a.w || r.target) - r.target) - Math.abs((b.w || r.target) - r.target) || a.v[2] - b.v[2])
      .filter((x) => (seen.has(x.it.h) ? false : seen.add(x.it.h)));
  }

  /* une pièce : le produit préféré (réglages) sinon le moins cher, variante la plus proche d'une valeur */
  function piece(kind, key, near, filter) {
    let list = byKind(kind);
    if (filter) list = list.filter(filter);
    list = sortPref(list.sort((a, b) => avail(a)[0][2] - avail(b)[0][2]), prefer(key));
    const it = list[0];
    if (!it) return null;
    let vs = avail(it);
    let v = vs[0];
    if (near != null) {
      const sized = vs.filter((x) => first(x[1]) != null);
      if (sized.length) v = sized.sort((a, b) => Math.abs(first(a[1]) - near) - Math.abs(first(b[1]) - near))[0];
    }
    if (R.sizes[key]) v = vs.find((x) => x[0] === R.sizes[key]) || v;
    return asLine(it, v, { key });
  }

  function buildSkate() {
    const kid = kidMode();
    const size = skateRange();
    const lines = [];
    const notes = [];
    let deckW = RANGE[size].target;
    let how = G.how;

    if (G.where === 'cruise') {
      const kids = kid ? pickWidth('complete', size, true).filter((x) => x.it.kid) : [];
      const list = kids.length ? kids : pickWidth('cruiser', size, kid);
      if (list.length) {
        const x = list[(R.alt.skate || 0) % list.length];
        lines.push(asLine(x.it, x.v, { key: 'board', role: kid && kids.length ? ROLE.complete : ROLE.cruiser, alts: list.length, slot: 'skate', vs: null }));
      }
    } else if (how === 'ready') {
      const list = pickWidth('complete', size, kid);
      if (list.length) {
        const x = list[(R.alt.skate || 0) % list.length];
        lines.push(asLine(x.it, x.v, { key: 'board', role: ROLE.complete, alts: list.length, slot: 'skate', vs: null }));
      } else {
        notes.push("Pas de skate complet à cette taille en stock : voici le sur mesure, monté gratuitement.");
        how = 'custom';
      }
    }

    if (G.where !== 'cruise' && how === 'custom') {
      const decks = pickWidth('deck', size, kid);
      if (decks.length) {
        const x = decks[(R.alt.skate || 0) % decks.length];
        deckW = x.w || deckW;
        lines.push(asLine(x.it, x.v, { key: 'deck', role: ROLE.deck + ' (' + String(x.w).replace('.', ',') + '")', alts: decks.length, slot: 'skate', vs: null }));
      } else {
        lines.push({ ask: 'Planche ' + RANGE[size].label, role: 'On te la choisit au shop' });
      }
      const kit = piece('kit', 'trucks');
      const kitOk = !!kit && deckW >= 7.9 && deckW <= 8.4;
      if (R.mode == null) R.mode = kitOk ? 'kit' : 'solo';
      if (!kitOk) R.mode = 'solo';
      R.kitOk = kitOk;
      if (R.mode === 'kit') {
        lines.push({ ...kit, role: ROLE.kit, vs: null });
      } else {
        const tr = byKind('trucks');
        const isMm = tr.some((it) => it.vs.some((v) => first(v[1]) > 30));
        const t = piece('trucks', 'trucks_solo', isMm && !prefer('trucks_solo') ? 139 + (deckW - 8) * 20 : deckW - 2.75,
          (it) => it.vs.filter((v) => first(v[1]) != null).length > 1);
        if (t) lines.push({ ...t, role: ROLE.trucks + ' · taille ' + t.vt, vs: null });
        const hard = (it) => /(9[5-9]|10[0-4])\s*[ab]/i.test(it.t + ' ' + it.vs.map((v) => v[1]).join(' '));
        const w = piece('wheels', 'wheels', kid || size === 's' || size === 'm' ? 52 : 54, hard) || piece('wheels', 'wheels', 53);
        if (w) lines.push({ ...w, role: ROLE.wheels + ' · ' + String(w.vt).toLowerCase(), vs: null });
        const b = piece('bearings', 'bearings');
        if (b) lines.push({ ...b, role: ROLE.bearings, vs: null });
        const hw = piece('hardware', 'hardware');
        if (hw) lines.push({ ...hw, role: ROLE.hardware, vs: null });
      }
      lines.push({ free: 'Grip posé au montage', role: ROLE.grip });
    }

    const safety = [];
    const kidOk = (it) => (kid ? it.kid : !it.kid);
    const helmet = piece('helmet', kid ? 'helmet_kid' : 'helmet', null, kidOk) || piece('helmet', 'helmet');
    if (helmet) safety.push({ ...helmet, role: ROLE.helmet });
    const pads = piece('pads', kid ? 'pads_kid' : 'pads', null, (it) => kidOk(it) && /pack/i.test(it.t)) || piece('pads', 'pads', null, kidOk);
    if (pads) safety.push({ ...pads, role: ROLE.pads });
    return { lines, safety, notes, how };
  }

  /* outfit : un haut, un bas, un couvre-chef, des shoes, en stock à la bonne taille */
  function outfitSlot(slot) {
    const kid = kidMode();
    let list = byKind(slot).filter((it) => (slot === 'cap' || (kid && slot === 'top') ? true : kid ? it.kid : !it.kid));
    const sub = R.sub[slot];
    if (sub && (slot === 'top' || slot === 'cap')) list = list.filter((it) => (sub === 'tee' ? !['sweat', 'jacket', 'beanie'].includes(it.s) : it.s === sub));
    const ok = (v) => {
      const s = sizeTok(v);
      if (slot === 'top') return s === String(G.top).toUpperCase();
      if (slot === 'bottom') return (BOTTOM[G.bottom] || [G.bottom]).includes(s);
      if (slot === 'shoes') return first(v[1]) != null && Math.abs(first(v[1]) - G.shoe) <= 0.5;
      return true;
    };
    const out = [];
    list.forEach((it) => {
      const vs = avail(it).filter(ok);
      if (!vs.length) return;
      let v = vs[0];
      if (slot === 'shoes') v = vs.sort((a, b) => Math.abs(first(a[1]) - G.shoe) - Math.abs(first(b[1]) - G.shoe))[0];
      if (slot === 'cap' && kid) v = vs.find((x) => /kid/i.test(x[1])) || v;
      const fit = String(it.fit || '').toLowerCase();
      const score = G.style === 'baggy' ? (fit.includes('baggy') ? -1 : 0) : G.style === 'regular' ? (fit.includes('baggy') ? 1 : 0) : 0;
      out.push({ it, v, score });
    });
    out.sort((a, b) => a.score - b.score);
    return out;
  }

  function buildOutfit() {
    const lines = [];
    const kid = kidMode();
    const slots = ['top', kid ? null : 'bottom', 'cap', G.shoe > 35 || !kid ? 'shoes' : null].filter(Boolean);
    slots.forEach((slot) => {
      if ((slot === 'top' || slot === 'cap') && R.sub[slot] === undefined) {
        R.sub[slot] = 'tee';
        if (!outfitSlot(slot).length) R.sub[slot] = null;
      }
      const list = outfitSlot(slot);
      if (!list.length) return;
      const x = list[(R.alt[slot] || 0) % list.length];
      let v = x.v;
      if (R.sizes[slot]) v = avail(x.it).find((y) => y[0] === R.sizes[slot]) || v;
      const label = slot === 'shoes' ? ROLE.shoes + ' · pointure ' + v[1] : slot === 'cap' ? ROLE.cap : ROLE[slot] + ' · taille ' + sizeTok(v);
      lines.push(asLine(x.it, v, { key: slot, slot, role: label, alts: list.length, off: !!R.off[slot], b: x.it.b }));
    });
    return lines;
  }

  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  function steps() {
    const S = [];
    S.push({ k: 'goal', q: "Salut ! Tu viens pour quoi ? Je te compose un combo en 1 minute.",
      o: [['skate', 'Mon skate', 'Planche, skate complet ou cruiser'], ['outfit', 'Mon outfit', 'De la basket à la casquette'], ['both', 'Les deux', 'Le skate et le style qui va avec']] });
    S.push({ k: 'who', q: "C'est pour qui ?", two: true,
      o: [['me', 'Pour moi'], ['kid', 'Pour mon enfant']] });
    if (wants('skate')) {
      S.push({ k: 'level', q: kidMode() ? 'Il ou elle en est où en skate ?' : 'Tu en es où en skate ?',
        o: [['new', 'Je débute', 'Premier skate, ou presque'], ['ride', 'Je roule déjà', 'Je sais ce que je veux, montre-moi le matos']] });
    }
    S.push({ k: 'shoe', q: (kidMode() ? 'Il ou elle chausse du combien ?' : 'Tu chausses du combien ?') + (wants('skate') ? " C'est ça qui donne la largeur de planche." : ''), three: true,
      o: [[35, '35 ou -'], [36, '36'], [37, '37'], [38, '38'], [39, '39'], [40, '40'], [41, '41'], [42, '42'], [43, '43'], [44, '44'], [45, '45 et +']] });
    if (wants('skate')) {
      S.push({ k: 'where', q: 'Pour rider où ?',
        o: [['street', 'Skatepark et street', 'Tricks, rampes, curbs'], ['cruise', 'Balade en ville', 'Rouler tranquille, se déplacer'], ['idk', 'Je sais pas encore', 'On part sur un skate polyvalent']] });
      if (G.where !== 'cruise') {
        const ready = feed && G.shoe ? pickWidth('complete', skateRange(), kidMode()) : [];
        const from = ready.length ? ' · dès ' + money(Math.min(...ready.map((x) => x.v[2]))) : '';
        S.push(G.level === 'ride'
          ? { k: 'how', q: 'Tu pars sur quoi ?',
            o: [['custom', 'Sur mesure', 'Planche et pièces à ton goût · montage et grip offerts'], ['ready', 'Skate complet', 'Déjà monté' + from]] }
          : { k: 'how', q: 'Comment tu veux commencer ?',
            o: [['ready', 'Prêt à rouler (conseillé)', 'Skate complet déjà monté' + from], ['custom', 'Sur mesure', 'Tu choisis ta planche · montage et grip offerts']] });
      }
    }
    if (wants('outfit')) {
      S.push(kidMode()
        ? { k: 'top', q: 'Quelle taille en haut ?', two: true, o: [['6-8', '6-8 ans'], ['8-10', '8-10 ans'], ['10-12', '10-12 ans'], ['12-14', '12-14 ans']] }
        : { k: 'top', q: 'Ta taille en haut ?', three: true, o: [['XS', 'XS'], ['S', 'S'], ['M', 'M'], ['L', 'L'], ['XL', 'XL'], ['XXL', 'XXL']] });
      if (!kidMode()) {
        S.push({ k: 'bottom', q: 'Et en bas ?', three: true, o: [['XS', 'XS · 26'], ['S', 'S · 28'], ['M', 'M · 30'], ['L', 'L · 32'], ['XL', 'XL · 34']] });
      }
      S.push({ k: 'style', q: 'Ton style ?',
        o: [['baggy', 'Large, baggy', 'Pantalon ample, sweat oversize'], ['regular', 'Classique', 'Coupe droite, ni trop large ni trop près'], ['any', 'Surprends-moi', "On mélange, c'est Rouli qui choisit"]] });
    }
    return S.filter((s) => s.k !== 'goal' || !R.preset);
  }

  /* attente du catalogue : Rouli fait patienter, puis propose de réessayer si ça casse */
  const WAIT = [
    [0, ['Rouli te prépare un combo aux petits oignons…', 'Deux secondes, je règle mes trucks.', 'Je regarde ce qui roule le mieux ensemble.']],
    [3000, ['Une bonne ligne, ça se prépare.', 'Attends, je replaque ça proprement.', 'Rouli fouille dans les rayons…']],
    [6000, ['Petite gamelle… mais ça repart.', 'Ça passe toujours au troisième essai.', 'Le réseau pousse un peu moins fort qu\u2019un jour sans vent…']],
    [10000, ['La connexion fait un peu de flat aujourd\u2019hui. Rouli s\u2019accroche.', 'Promis, ton combo arrive — je vérifie juste les dernières tailles.']],
  ];
  function waitFeed(total) {
    const timers = [];
    const show = (text) => {
      body.innerHTML = '';
      body.append(head(total, total), bubble(text));
      const dots = el('div', 'cr-g-wait');
      dots.innerHTML = '<i></i><i></i><i></i>';
      body.appendChild(dots);
    };
    WAIT.forEach(([at, lines]) => timers.push(window.setTimeout(() => show(lines[Math.floor(Math.random() * lines.length)]), at)));
    loadFeed().then((res) => {
      timers.forEach(window.clearTimeout);
      if (res && res.length) { render(); return; }
      body.innerHTML = '';
      body.append(head(total, total), bubble('Oups, Rouli vient de prendre une vraie gamelle. On retente ?'));
      const retry = el('button', 'cr-g-add', 'Réessayer');
      retry.type = 'button';
      retry.addEventListener('click', () => waitFeed(total));
      body.appendChild(retry);
    });
  }

  function head(total, done) {
    const h = el('div', 'cr-g-head');
    const back = el('button', 'cr-sheet__close');
    back.type = 'button';
    if (hist.length) {
      back.setAttribute('aria-label', 'Question précédente');
      back.innerHTML = '<svg class="cr-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
      back.addEventListener('click', () => {
        const k = hist.pop();
        delete G[k];
        R.alt = {};
        R.sizes = {};
        R.mode = null;
        render();
      });
    } else {
      back.style.visibility = 'hidden';
      back.tabIndex = -1;
    }
    const dots = el('div', 'cr-g-dots');
    for (let i = 0; i < total; i++) dots.appendChild(el('i', i < done ? 'on' : ''));
    const close = el('button', 'cr-sheet__close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Fermer');
    close.setAttribute('data-cr-close', '');
    close.innerHTML = '<svg class="cr-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    h.append(back, dots, close);
    return h;
  }

  function bubble(text) {
    const s = el('div', 'cr-g-say');
    const av = el('span', 'cr-g-av');
    av.innerHTML = art;
    s.append(av, el('p', '', text));
    return s;
  }

  function lineEl(x) {
    const row = el('div', 'cr-g-line' + (x.off ? ' is-off' : ''));
    const m = el('div', 'm');
    if (x.free) {
      const ph = el('span', 'cr-g-ph cr-g-ph--ok');
      ph.innerHTML = '<svg class="cr-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
      m.append(el('b', '', x.free), el('span', '', x.role));
      row.append(ph, m, el('em', 'cr-g-free', 'Offert'));
      return row;
    }
    if (x.ask) {
      m.append(el('b', '', x.ask), el('span', '', x.role));
      row.append(el('span', 'cr-g-ph'), m, el('em', '', 'Au shop'));
      return row;
    }
    const img = document.createElement('img');
    img.src = x.img || '';
    img.alt = '';
    img.width = 58;
    img.height = 58;
    img.loading = 'lazy';
    m.append(el('b', '', x.t), el('span', '', x.role));
    const tools = el('div', 'cr-g-tools');
    if (x.vs) {
      const lab = el('label', 'cr-g-size');
      lab.append(el('span', 'cr-vh', 'Taille'));
      const sel = document.createElement('select');
      x.vs.forEach((v) => {
        const o = document.createElement('option');
        o.value = v[0];
        o.textContent = String(v[1]).length <= 6 ? 'Taille ' + v[1] : v[1];
        if (v[0] === x.v) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', () => { R.sizes[x.key] = Number(sel.value); render(true); });
      lab.appendChild(sel);
      tools.appendChild(lab);
    }
    if (x.alts > 1 && !x.off) {
      const b = el('button', 'cr-g-swap', 'Autre modèle (' + x.alts + ')');
      b.type = 'button';
      b.addEventListener('click', () => { R.alt[x.slot] = (R.alt[x.slot] || 0) + 1; delete R.sizes[x.key]; render(true); });
      tools.appendChild(b);
    }
    if (x.slot && x.slot !== 'skate') {
      const b = el('button', 'cr-g-swap cr-g-swap--mute', x.off ? 'Remettre' : 'Retirer');
      b.type = 'button';
      b.addEventListener('click', () => { R.off[x.slot] = !R.off[x.slot]; render(true); });
      tools.appendChild(b);
    }
    if (tools.children.length) m.appendChild(tools);
    row.append(img, m, el('em', '', money(x.c)));
    return row;
  }

  function seg(options, current, onPick) {
    const s = el('div', 'cr-g-seg' + (options.length > 2 ? ' three' : ''));
    options.forEach(([k, label]) => {
      const b = el('button', current === k ? 'is-on' : '', label);
      b.type = 'button';
      b.setAttribute('aria-pressed', String(current === k));
      b.addEventListener('click', () => onPick(k));
      s.appendChild(b);
    });
    return s;
  }

  function sw(label, on, onChange) {
    const s = el('button', 'cr-switch');
    s.type = 'button';
    s.setAttribute('role', 'switch');
    s.setAttribute('aria-label', label);
    s.setAttribute('aria-checked', String(!!on));
    s.addEventListener('click', onChange);
    return s;
  }

  function render(keepScroll) {
    const panel = guide.querySelector('.cr-sheet__panel');
    const y = keepScroll && panel ? panel.scrollTop : 0;
    body.innerHTML = '';
    const S = steps();
    const current = S.find((s) => G[s.k] === undefined);
    const done = S.filter((s) => G[s.k] !== undefined).length;
    body.appendChild(head(S.length + 1, done + (current ? 1 : 1)));

    if (current) {
      body.appendChild(bubble(current.q));
      const opts = el('div', 'cr-g-opts' + (current.two ? ' two' : '') + (current.three ? ' three' : ''));
      current.o.forEach((o) => {
        const b = el('button', 'cr-g-opt');
        b.type = 'button';
        const label = el('span', '', o[1]);
        if (o[2]) label.appendChild(el('small', '', o[2]));
        b.appendChild(label);
        b.addEventListener('click', () => {
          G[current.k] = o[0];
          hist.push(current.k);
          if (current.k === 'where' && o[0] === 'cruise') delete G.how;
          const left = steps().find((s) => G[s.k] === undefined);
          if (!left && !feed) {
            waitFeed(S.length + 1);
            return;
          }
          render();
        });
        opts.appendChild(b);
      });
      body.appendChild(opts);
      /* parcours choisi par la page : on peut toujours changer d'avis */
      if (R.preset && !hist.length && (G.goal === 'skate' || G.goal === 'outfit')) {
        const other = G.goal === 'skate' ? 'outfit' : 'skate';
        const sw2 = el('button', 'cr-g-link', other === 'outfit' ? 'Tu cherches plutôt un outfit ? →' : 'Tu cherches plutôt un skate ? →');
        sw2.type = 'button';
        sw2.addEventListener('click', () => { G = { goal: other }; render(); });
        body.appendChild(sw2);
        const both = el('button', 'cr-g-link cr-g-link--mute', 'Ou les deux, le combo complet →');
        both.type = 'button';
        both.addEventListener('click', () => { G = { goal: 'both' }; render(); });
        body.appendChild(both);
      }
      const f = opts.querySelector('button');
      if (f) f.focus({ preventScroll: true });
      if (panel) panel.scrollTop = 0;
      return;
    }

    const kid = kidMode();
    const skate = wants('skate') ? buildSkate() : null;
    const outfit = wants('outfit') ? buildOutfit() : [];
    if (R.safety == null) R.safety = kid;
    if (R.lesson == null) R.lesson = G.where === 'idk';

    body.appendChild(bubble(
      G.goal === 'both' ? "Le combo complet : le skate, et le style qui va avec."
        : G.goal === 'outfit' ? 'Ton outfit, de la basket à la casquette. Tout est en stock à ta taille : change une pièce si tu veux.'
          : G.where === 'cruise' ? 'Voilà ton setup balade. Casque sur la tête et ça roule.'
            : G.level === 'ride' ? (skate.how === 'ready' ? 'Un complet à ta taille, prêt à rouler. Change ce que tu veux.' : 'Un setup à ta largeur. Change ce que tu veux, on monte tout au shop.')
              : skate.how === 'ready' ? 'Voilà ton skate, déjà monté. Tu le sors du carton et tu roules.'
                : 'Voilà ton setup sur mesure. On le monte avec toi au shop, grip compris.'
    ));

    let buy = [];
    let skateBuy = [];
    let outfitBuy = [];
    if (skate) {
      skate.notes.forEach((n) => body.appendChild(el('p', 'cr-g-note', n)));
      if (G.where !== 'cruise') {
        const w = el('div', 'cr-g-width');
        w.append(el('span', '', 'Largeur conseillée pour ' + (kid ? 'sa' : 'ta') + ' pointure'), el('b', '', RANGE[skateRange()].label));
        body.appendChild(w);
      }
      body.appendChild(el('p', 'cr-g-sec', skate.how === 'custom' && G.where !== 'cruise' ? 'Le skate, pièce par pièce' : 'Le skate'));
      skate.lines.forEach((x, i) => {
        body.appendChild(lineEl(x));
        if (i === 0 && G.where !== 'cruise' && skate.how === 'custom' && R.kitOk) {
          body.appendChild(seg([['kit', 'Pack tout-en-un'], ['solo', 'Trucks séparés']], R.mode, (k) => { R.mode = k; render(true); }));
        }
      });
      if (G.where !== 'cruise' && skate.how === 'custom') {
        const a = el('div', 'cr-g-atelier');
        a.innerHTML = '<svg class="cr-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M14.7 6.3a4 4 0 0 0-5.2 5.2L4 17l3 3 5.5-5.5a4 4 0 0 0 5.2-5.2l-2.4 2.4-2.6-.6-.6-2.6z"/></svg>';
        const t = el('div');
        t.append(el('b', '', 'Montage et grip offerts'), el('span', '', "On monte ta planche avec toi au shop, et on t'apprend à le faire toi-même."));
        a.appendChild(t);
        body.appendChild(a);
      }
      skateBuy = skateBuy.concat(skate.lines.filter((x) => x.v));
      if (skate.safety.length) {
        const r = el('div', 'cr-g-row');
        const t = el('div');
        t.append(el('b', '', 'Casque et protections'), el('span', '', kid ? 'Fortement conseillé pour un enfant' : G.level === 'ride' ? 'En option' : 'Conseillé pour débuter'));
        r.append(t, sw('Ajouter casque et protections', R.safety, () => { R.safety = !R.safety; render(true); }));
        body.appendChild(r);
        skate.safety.forEach((x) => body.appendChild(lineEl({ ...x, off: !R.safety })));
        if (R.safety) skateBuy = skateBuy.concat(skate.safety.filter((x) => x.v));
      }
    }

    if (wants('outfit')) {
      body.appendChild(el('p', 'cr-g-sec', G.goal === 'both' ? 'Et le style qui va avec' : 'De la basket à la casquette'));
      if (!outfit.length) body.appendChild(el('p', 'cr-g-note', "Rien en stock à ces tailles pour l'instant. Passe au shop, on te trouve ça."));
      outfit.forEach((x) => {
        if (x.slot === 'top' || x.slot === 'cap') {
          const opts = x.slot === 'top' ? TOPSUB : CAPSUB;
          const present = opts.filter(([k]) => { const keep = R.sub[x.slot]; R.sub[x.slot] = k; const n = outfitSlot(x.slot).length; R.sub[x.slot] = keep; return n > 0; });
          if (present.length > 1) body.appendChild(seg(present, R.sub[x.slot] || 'tee', (k) => { R.sub[x.slot] = k; R.alt[x.slot] = 0; delete R.sizes[x.slot]; render(true); }));
        }
        body.appendChild(lineEl(x));
      });
      outfitBuy = outfit.filter((x) => x.v && !x.off);
    }

    if (wants('skate') && items.lesson && G.level !== 'ride') {
      const r = el('div', 'cr-g-row');
      const t = el('div');
      t.append(el('b', '', 'Ajouter un cours particulier'), el('span', '', items.lesson.t + ' · ' + items.lesson.p));
      r.append(t, sw('Ajouter un cours particulier', R.lesson, () => { R.lesson = !R.lesson; render(true); }));
      body.appendChild(r);
      if (R.lesson && items.lesson.v) skateBuy.push({ v: items.lesson.v, c: items.lesson.c });
    }

    const sum = (l) => l.reduce((t, x) => t + x.c, 0);
    const bothOffer = G.goal === 'both' && skateBuy.length && outfitBuy.length;
    if (!bothOffer) R.pack = G.goal === 'outfit' || !skateBuy.length ? 'outfit' : G.goal === 'skate' || !outfitBuy.length ? 'skate' : R.pack;
    let gifts = ['gift1', 'gift2', 'gift3', 'gift4'].map((k) => items[k]).filter((g) => g && g.ok && g.v && g.c === 0);
    /* sans produit cadeau à 0 €, le choix est noté sur la commande (attribut « Cadeau Rouli ») */
    if (!gifts.length) gifts = (data.giftNames || []).map((n) => String(n).trim()).filter(Boolean).map((n) => ({ t: n, v: n, c: 0, note: true }));

    if (bothOffer) {
      body.appendChild(el('p', 'cr-g-sec', 'Tu prends quoi ?'));
      const packs = el('div', 'cr-g-packs');
      [['skate', 'Le skate', sum(skateBuy), ''], ['outfit', "L'outfit", sum(outfitBuy), ''], ['both', 'Les deux', sum(skateBuy) + sum(outfitBuy), gifts.length ? '+ un petit cadeau de Rouli' : '']].forEach(([k, label, price, extra]) => {
        const b = el('button', 'cr-g-pack' + (R.pack === k ? ' is-on' : '') + (k === 'both' ? ' cr-g-pack--both' : ''));
        b.type = 'button';
        b.setAttribute('aria-pressed', String(R.pack === k));
        b.append(el('b', '', label), el('span', '', money(price)));
        if (extra) b.appendChild(el('small', '', '🎁 ' + extra));
        b.addEventListener('click', () => { R.pack = k; if (k !== 'both') R.gift = null; render(true); });
        packs.appendChild(b);
      });
      body.appendChild(packs);
    }
    buy = R.pack === 'both' ? skateBuy.concat(outfitBuy) : R.pack === 'outfit' ? outfitBuy : R.pack === 'skate' ? skateBuy : [];

    /* le petit cadeau : pour ceux qui prennent le combo complet, jamais forcé */
    /* un combo, c'est un combo : tout ce que Rouli a proposé est gardé (au moins 2 pièces), ou « Les deux » */
    const removed = Object.values(R.off || {}).some(Boolean);
    const giftOk = gifts.length && (R.pack === 'both' || (buy.length >= 2 && !removed));
    if (!giftOk) R.gift = null;
    if (!giftOk && gifts.length && removed && (!bothOffer || R.pack)) {
      body.appendChild(el('p', 'cr-g-note cr-g-note--gift', '🎁 Remets la pièce retirée, et Rouli t\u2019offre un petit cadeau.'));
    }
    if (giftOk) {
      const g = el('div', 'cr-g-gift');
      g.append(el('b', '', 'Un combo, c\u2019est un combo : Rouli t\u2019offre un petit cadeau.'), el('span', '', 'Qu\u2019est-ce qui te ferait plaisir ?'));
      const chips = el('div', 'cr-chips cr-chips--wrap');
      gifts.forEach((gi) => {
        const c = el('button', 'cr-chip' + (R.gift === gi.v ? ' is-on' : ''), gi.t);
        c.type = 'button';
        c.setAttribute('aria-pressed', String(R.gift === gi.v));
        c.addEventListener('click', () => { R.gift = R.gift === gi.v ? null : gi.v; render(true); });
        chips.appendChild(c);
      });
      g.appendChild(chips);
      body.appendChild(g);
    }

    const total = sum(buy);
    body.appendChild(el('p', 'cr-g-note', 'Un doute sur une taille ? On vérifie tout avec toi au shop.'));
    const label = () => (bothOffer && !R.pack ? 'Choisis ton combo' : 'Ajouter au panier · ' + money(total) + (R.gift ? ' + 🎁' : ''));
    const add = el('button', 'cr-g-add', label());
    add.type = 'button';
    if (!buy.length) add.disabled = true;
    const err = el('p', 'cr-g-err');
    err.hidden = true;
    add.addEventListener('click', async () => {
      add.disabled = true;
      add.textContent = 'Ajout en cours…';
      const lines = buy.map((x) => ({ id: x.v, quantity: 1 }));
      const giftPick = gifts.find((g) => g.v === R.gift);
      if (giftPick && !giftPick.note) lines.push({ id: giftPick.v, quantity: 1, properties: { _Cadeau: 'Rouli' } });
      try {
        const res = await fetch(data.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines }),
        });
        if (!res.ok) throw new Error(String(res.status));
        if (giftPick && giftPick.note) {
          await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Cadeau Rouli': giftPick.t } }) }).catch(() => {});
        }
        window.location.href = data.cart;
      } catch (e) {
        add.disabled = false;
        add.textContent = label();
        err.hidden = false;
        err.textContent = "L'ajout n'a pas marché. Réessaie, ou ajoute les pièces une par une.";
      }
    });
    body.append(add, err);

    if (G.goal !== 'both') {
      const more = el('button', 'cr-g-link', G.goal === 'skate' ? "Et l'outfit qui va avec ? →" : 'Et un skate pour rouler avec ? →');
      more.type = 'button';
      more.addEventListener('click', () => { G.goal = 'both'; R.preset = true; render(); });
      body.appendChild(more);
    }
    if (panel) panel.scrollTop = y;
  }

  /* ---------- Rouli sur la fiche produit : « Il te manque… » / « Complète le look » ---------- */
  const comboBox = document.querySelector('[data-cr-combo]');
  if (comboBox) {
    const CB = { off: {}, alt: {}, size: {} };
    const LETTER_OF_WAIST = { 26: 'XS', 27: 'XS', 28: 'S', 29: 'S', 30: 'M', 31: 'M', 32: 'L', 33: 'L', 34: 'XL', 35: 'XL', 36: 'XL' };
    const currentId = () => {
      const f = document.querySelector('.product-details form[action*="/cart/add"] [name="id"], product-form-component [name="id"], form[action*="/cart/add"] [name="id"]');
      return Number((f && f.value) || comboBox.dataset.variant);
    };

    /* calcule le combo avec les règles du guide (G et R prêtés le temps du calcul) */
    function comboLines(me, v) {
      const saveG = G;
      const saveR = R;
      const lines = [];
      let title = '';
      let sub = '';
      try {
        R = { alt: CB.alt, sizes: {}, sub: {}, off: {}, mode: null };
        const k = me.k;
        if (k === 'deck') {
          const w = widthOf(me, v) || 8;
          title = 'Pour rouler, il te manque…';
          sub = 'Montage et grip offerts au shop.';
          const kit = piece('kit', 'trucks');
          if (kit && w >= 7.9 && w <= 8.4) {
            lines.push({ ...kit, role: ROLE.kit, slot: 'kit', vs: null });
          } else {
            const tr = byKind('trucks');
            const isMm = tr.some((it) => it.vs.some((x) => first(x[1]) > 30));
            const t = piece('trucks', 'trucks_solo', isMm && !prefer('trucks_solo') ? 139 + (w - 8) * 20 : w - 2.75, (it) => it.vs.filter((x) => first(x[1]) != null).length > 1);
            if (t) lines.push({ ...t, role: ROLE.trucks + ' · taille ' + t.vt, slot: 'trucks', vs: null });
            const hard = (it) => /(9[5-9]|10[0-4])\s*[ab]/i.test(it.t + ' ' + it.vs.map((x) => x[1]).join(' '));
            const wh = piece('wheels', 'wheels', w < 7.9 ? 52 : 53, hard) || piece('wheels', 'wheels', 53);
            if (wh) lines.push({ ...wh, role: ROLE.wheels + ' · ' + String(wh.vt).toLowerCase(), slot: 'wheels', vs: null });
            const b = piece('bearings', 'bearings');
            if (b) lines.push({ ...b, role: ROLE.bearings, slot: 'bearings', vs: null });
            const hw = piece('hardware', 'hardware');
            if (hw) lines.push({ ...hw, role: ROLE.hardware, slot: 'hardware', vs: null });
          }
          lines.push({ free: 'Grip posé au montage', role: ROLE.grip, slot: 'grip' });
        } else if (k === 'trucks') {
          title = 'Pour finir le dessous de ta planche';
          sub = 'On monte tout gratuitement au shop.';
          const wh = piece('wheels', 'wheels', 53);
          if (wh) lines.push({ ...wh, role: ROLE.wheels, slot: 'wheels' });
          const b = piece('bearings', 'bearings');
          if (b) lines.push({ ...b, role: ROLE.bearings, slot: 'bearings', vs: null });
          const hw = piece('hardware', 'hardware');
          if (hw) lines.push({ ...hw, role: ROLE.hardware, slot: 'hardware', vs: null });
        } else if (k === 'wheels') {
          title = 'Sans roulements, ça roule pas';
          sub = 'On les monte gratuitement au shop.';
          const b = piece('bearings', 'bearings');
          if (b) lines.push({ ...b, role: ROLE.bearings, slot: 'bearings', vs: null });
        } else if (k === 'complete' || k === 'cruiser' || k === 'kit') {
          title = k === 'kit' ? 'Et la planche qui va dessus' : 'Pour débuter en sécurité';
          sub = k === 'kit' ? 'Montage et grip offerts au shop.' : 'Casque et protections, à ta taille.';
          if (k === 'kit') {
            const decks = pickWidth('deck', 'l', false);
            if (decks.length) {
              const x = decks[(CB.alt.deck || 0) % decks.length];
              lines.push(asLine(x.it, x.v, { slot: 'deck', role: ROLE.deck + ' (' + String(x.w).replace('.', ',') + '")', alts: decks.length, vs: null }));
            }
          } else {
            const kid = me.kid;
            const kidOk = (it) => (kid ? it.kid : !it.kid);
            const h = piece('helmet', kid ? 'helmet_kid' : 'helmet', null, kidOk) || piece('helmet', 'helmet');
            if (h) lines.push({ ...h, role: ROLE.helmet, slot: 'helmet' });
            const pd = piece('pads', kid ? 'pads_kid' : 'pads', null, (it) => kidOk(it) && /pack/i.test(it.t)) || piece('pads', 'pads', null, kidOk);
            if (pd) lines.push({ ...pd, role: ROLE.pads, slot: 'pads' });
          }
        } else if (['top', 'bottom', 'cap', 'shoes'].includes(k)) {
          title = 'Complète le look';
          sub = 'De la basket à la casquette, en stock à ta taille.';
          const tok = sizeTok(v);
          let top = 'M';
          let bottom = 'M';
          if (k === 'top' && /^(XS|S|M|L|XL|XXL|\d+-\d+)$/.test(tok)) { top = tok; bottom = BOTTOM[tok] ? tok : 'M'; }
          if (k === 'bottom') { bottom = BOTTOM[tok] ? tok : LETTER_OF_WAIST[first(tok)] || 'M'; top = bottom; }
          G = { who: me.kid ? 'kid' : 'me', top, bottom, shoe: k === 'shoes' ? first(v[1]) : 42, style: /baggy/i.test(me.fit || '') ? 'baggy' : 'any', goal: 'outfit' };
          const slots = { top: ['bottom', 'cap', 'shoes'], bottom: ['top', 'cap', 'shoes'], cap: ['top', 'bottom', 'shoes'], shoes: ['top', 'bottom', 'cap'] }[k];
          slots.forEach((slot) => {
            if (me.kid && slot === 'bottom') return;
            let list = outfitSlot(slot);
            if (slot === 'shoes' && k !== 'shoes') {
              /* pointure inconnue : on propose une paire, la pointure se choisit dans la liste */
              list = byKind('shoes').filter((it) => !it.kid && it.h !== me.h).map((it) => ({ it, v: null, score: 0 }));
            }
            list = list.filter((x) => x.it.h !== me.h);
            if (!list.length) return;
            const x = list[(CB.alt[slot] || 0) % list.length];
            const vs = avail(x.it);
            let vv = x.v;
            if (CB.size[slot]) vv = vs.find((y) => y[0] === CB.size[slot]) || vv;
            const needSize = !vv;
            const label = slot === 'shoes' ? (needSize ? 'Aux pieds · choisis ta pointure' : 'Aux pieds · pointure ' + vv[1]) : slot === 'cap' ? ROLE.cap : ROLE[slot] + ' · taille ' + sizeTok(vv || vs[0]);
            lines.push({ t: x.it.t, img: x.it.img, h: x.it.h, v: vv ? vv[0] : null, c: (vv || vs[0])[2], vt: vv ? vv[1] : null, vs: vs.length > 1 ? vs : null, needSize, slot, role: label, alts: list.length });
          });
        }
      } finally {
        G = saveG;
        R = saveR;
      }
      return { title, sub, lines };
    }

    function renderCombo() {
      const me = (feed || []).find((it) => it.h === comboBox.dataset.handle);
      if (!me) { comboBox.hidden = true; return; }
      const id = currentId();
      const v = me.vs.find((x) => x[0] === id) || avail(me)[0];
      const { title, sub, lines } = comboLines(me, v);
      if (!lines.filter((x) => !x.free).length) { comboBox.hidden = true; return; }
      comboBox.innerHTML = '';
      const head = el('div', 'cr-combo__head');
      const av = el('span', 'cr-g-av');
      av.innerHTML = art;
      const t = el('div');
      t.append(el('b', 'cr-combo__title', title), el('span', 'cr-combo__sub', sub));
      head.append(av, t);
      comboBox.appendChild(head);

      lines.forEach((x) => {
        const row = el('div', 'cr-g-line' + (CB.off[x.slot] ? ' is-off' : ''));
        const m = el('div', 'm');
        if (x.free) {
          const ph = el('span', 'cr-g-ph cr-g-ph--ok');
          ph.innerHTML = '<svg class="cr-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';
          m.append(el('b', '', x.free), el('span', '', x.role));
          row.append(ph, m, el('em', 'cr-g-free', 'Offert'));
          comboBox.appendChild(row);
          return;
        }
        const a = document.createElement('a');
        a.href = '/products/' + x.h;
        a.className = 'cr-combo__img';
        const img = document.createElement('img');
        img.src = x.img || '';
        img.alt = x.t;
        img.width = 58;
        img.height = 58;
        img.loading = 'lazy';
        a.appendChild(img);
        const name = document.createElement('a');
        name.href = '/products/' + x.h;
        name.className = 'cr-combo__name';
        name.textContent = x.t;
        m.append(name, el('span', '', x.role));
        const tools = el('div', 'cr-g-tools');
        if (x.vs) {
          const lab = el('label', 'cr-g-size');
          lab.append(el('span', 'cr-vh', 'Taille de ' + x.t));
          const sel = document.createElement('select');
          if (x.needSize) {
            const o = document.createElement('option');
            o.value = '';
            o.textContent = x.slot === 'shoes' ? 'Pointure ?' : 'Taille ?';
            sel.appendChild(o);
          }
          x.vs.forEach((vv) => {
            const o = document.createElement('option');
            o.value = vv[0];
            o.textContent = String(vv[1]).length <= 6 ? (x.slot === 'shoes' ? 'Pointure ' : 'Taille ') + vv[1] : vv[1];
            if (vv[0] === x.v) o.selected = true;
            sel.appendChild(o);
          });
          sel.addEventListener('change', () => { CB.size[x.slot] = Number(sel.value) || undefined; renderCombo(); });
          lab.appendChild(sel);
          tools.appendChild(lab);
        }
        if (x.alts > 1 && !CB.off[x.slot]) {
          const b = el('button', 'cr-g-swap', 'Autre');
          b.type = 'button';
          b.addEventListener('click', () => { CB.alt[x.slot] = (CB.alt[x.slot] || 0) + 1; delete CB.size[x.slot]; renderCombo(); });
          tools.appendChild(b);
        }
        const rm = el('button', 'cr-g-swap cr-g-swap--mute', CB.off[x.slot] ? 'Remettre' : 'Retirer');
        rm.type = 'button';
        rm.addEventListener('click', () => { CB.off[x.slot] = !CB.off[x.slot]; renderCombo(); });
        tools.appendChild(rm);
        m.appendChild(tools);
        row.append(a, m, el('em', '', money(x.c)));
        comboBox.appendChild(row);
      });

      const buy = lines.filter((x) => x.v && !x.free && !CB.off[x.slot]);
      const waiting = lines.filter((x) => x.needSize && !x.v && !CB.off[x.slot]);
      const withMe = v && v[3];
      const total = buy.reduce((s, x) => s + x.c, 0) + (withMe ? v[2] : 0);
      const add = el('button', 'cr-g-add', (withMe ? 'Ajouter avec ce produit · ' : 'Ajouter · ') + money(total));
      add.type = 'button';
      if (!buy.length) add.disabled = true;
      const err = el('p', 'cr-g-err');
      err.hidden = true;
      add.addEventListener('click', async () => {
        add.disabled = true;
        add.textContent = 'Ajout en cours…';
        const itemsToAdd = buy.map((x) => ({ id: x.v, quantity: 1 }));
        if (withMe) itemsToAdd.unshift({ id: v[0], quantity: 1 });
        try {
          const res = await fetch(data.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itemsToAdd }) });
          if (!res.ok) throw new Error(String(res.status));
          window.location.href = data.cart;
        } catch (e) {
          add.disabled = false;
          add.textContent = (withMe ? 'Ajouter avec ce produit · ' : 'Ajouter · ') + money(total);
          err.hidden = false;
          err.textContent = "L'ajout n'a pas marché. Réessaie, ou ajoute les pièces une par une.";
        }
      });
      if (waiting.length) comboBox.appendChild(el('p', 'cr-g-note', 'Choisis la pointure pour ajouter les shoes, sinon elles restent de côté.'));
      comboBox.append(add, err);
      comboBox.hidden = false;
    }

    const later = () => window.setTimeout(renderCombo, 250);
    loadFeed().then(renderCombo);
    document.addEventListener('variant:update', later);
    document.addEventListener('change', (e) => {
      if (comboBox.contains(e.target)) return;
      if (e.target.closest('variant-picker, .variant-picker, [name="id"], [name^="options"]')) later();
    });
  }

  /* ---------- Rouli dans le panier : les pièces qui manquent pour rouler ---------- */
  function cartmate() {
    const attrOut = document.querySelector('[data-cr-cartmate][data-gift-attr-clear]');
    if (attrOut && !attrOut.dataset.removing) {
      attrOut.dataset.removing = '1';
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Cadeau Rouli': '' } }) })
        .then(() => window.location.reload());
      return;
    }
    const giftOut = document.querySelector('[data-cr-cartmate][data-gift-remove]');
    if (giftOut && !giftOut.dataset.removing) {
      giftOut.dataset.removing = '1';
      const keys = giftOut.dataset.giftRemove.split(',').filter(Boolean);
      const updates = {};
      keys.forEach((k) => { updates[k] = 0; });
      fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) })
        .then(() => window.location.reload());
      return;
    }
    document.querySelectorAll('[data-cr-cartmate]').forEach((box) => {
      const sig = box.dataset.kinds + box.dataset.decks;
      if (box.dataset.done === sig) return;
      box.dataset.done = sig;
      const fix = box.querySelector('.cr-cartmate__fix');
      if (!fix) return;
      fix.innerHTML = '';
      const kinds = box.dataset.kinds || '';
      const has = (k) => kinds.includes('|' + k + '|');
      const needs = [];
      if (has('deck') && !has('complete')) {
        if (!has('kit')) ['trucks', 'wheels', 'bearings', 'hardware'].forEach((k) => { if (!has(k)) needs.push(k); });
      } else if (has('trucks') && !has('kit')) {
        ['wheels', 'bearings', 'hardware'].forEach((k) => { if (!has(k)) needs.push(k); });
      } else if (has('wheels') && !has('bearings')) {
        needs.push('bearings');
      }
      const wantHelmet = (has('deck') || has('complete') || has('kit')) && !has('helmet');
      if (!needs.length && !wantHelmet) return;

      loadFeed().then(() => {
        const deck1 = (box.dataset.decks || '').split('¤')[0].split('§');
        const w = (deck1[0] && widthOf({ t: deck1[0] }, [0, deck1[1] || ''])) || 8.1;
        const kid = box.dataset.kid === 'true';
        const saveR = R;
        const lines = [];
        try {
          R = { alt: {}, sizes: {}, sub: {}, off: {}, mode: null };
          const kit = needs.length === 4 ? piece('kit', 'trucks') : null;
          if (kit && w >= 7.9 && w <= 8.4) {
            lines.push({ ...kit, role: ROLE.kit, on: true });
          } else {
            needs.forEach((k) => {
              let x = null;
              if (k === 'trucks') {
                const isMm = byKind('trucks').some((it) => it.vs.some((v) => first(v[1]) > 30));
                x = piece('trucks', 'trucks_solo', isMm && !prefer('trucks_solo') ? 139 + (w - 8) * 20 : w - 2.75, (it) => it.vs.filter((v) => first(v[1]) != null).length > 1);
                if (x) x.role = ROLE.trucks + ' · taille ' + x.vt;
              } else if (k === 'wheels') {
                const hard = (it) => /(9[5-9]|10[0-4])\s*[ab]/i.test(it.t + ' ' + it.vs.map((v) => v[1]).join(' '));
                x = piece('wheels', 'wheels', w < 7.9 ? 52 : 53, hard) || piece('wheels', 'wheels', 53);
                if (x) x.role = ROLE.wheels + ' · ' + String(x.vt).toLowerCase();
              } else {
                x = piece(k, k);
                if (x) x.role = ROLE[k];
              }
              if (x) lines.push({ ...x, vs: null, on: true });
            });
          }
          if (wantHelmet) {
            const kidOk = (it) => (kid ? it.kid : !it.kid);
            const h = piece('helmet', kid ? 'helmet_kid' : 'helmet', null, kidOk) || piece('helmet', 'helmet');
            if (h) lines.push({ ...h, role: ROLE.helmet + (kid ? ' · fortement conseillé pour un enfant' : ''), on: kid, optional: true });
          }
        } finally {
          R = saveR;
        }
        if (!lines.length) return;

        const draw = () => {
          fix.innerHTML = '';
          const card = el('div', 'cr-combo cr-combo--cart');
          const head = el('div', 'cr-combo__head');
          const av = el('span', 'cr-g-av');
          av.innerHTML = art;
          const t = el('div');
          const missing = lines.filter((x) => !x.optional).length;
          t.append(
            el('b', 'cr-combo__title', missing ? 'Il manque des pièces pour rouler' : 'Un casque avec ça ?'),
            el('span', 'cr-combo__sub', missing ? 'Rouli a trouvé celles qui vont avec ta planche.' : 'Pour débuter sereinement.')
          );
          head.append(av, t);
          card.appendChild(head);
          lines.forEach((x) => {
            const row = el('div', 'cr-g-line' + (x.on ? '' : ' is-off'));
            const img = document.createElement('img');
            img.src = x.img || '';
            img.alt = '';
            img.width = 58;
            img.height = 58;
            img.loading = 'lazy';
            const m = el('div', 'm');
            m.append(el('b', '', x.t), el('span', '', x.role));
            const tools = el('div', 'cr-g-tools');
            if (x.vs && x.on) {
              const lab = el('label', 'cr-g-size');
              lab.append(el('span', 'cr-vh', 'Taille de ' + x.t));
              const sel = document.createElement('select');
              x.vs.forEach((v) => {
                const o = document.createElement('option');
                o.value = v[0];
                o.textContent = String(v[1]).length <= 6 ? 'Taille ' + v[1] : v[1];
                if (v[0] === x.v) o.selected = true;
                sel.appendChild(o);
              });
              sel.addEventListener('change', () => { const v = x.vs.find((y) => y[0] === Number(sel.value)); if (v) { x.v = v[0]; x.c = v[2]; } draw(); });
              lab.appendChild(sel);
              tools.appendChild(lab);
            }
            const tg = el('button', 'cr-g-swap' + (x.on ? ' cr-g-swap--mute' : ''), x.on ? 'Retirer' : 'Ajouter');
            tg.type = 'button';
            tg.addEventListener('click', () => { x.on = !x.on; draw(); });
            tools.appendChild(tg);
            m.appendChild(tools);
            row.append(img, m, el('em', '', money(x.c)));
            card.appendChild(row);
          });
          const buy = lines.filter((x) => x.on && x.v);
          const total = buy.reduce((s, x) => s + x.c, 0);
          const add = el('button', 'cr-g-add', buy.length ? 'Ajouter ' + (buy.length > 1 ? 'les ' + buy.length + ' pièces' : 'au panier') + ' · ' + money(total) : 'Rien à ajouter');
          add.type = 'button';
          if (!buy.length) add.disabled = true;
          add.addEventListener('click', async () => {
            add.disabled = true;
            add.textContent = 'Ajout en cours…';
            try {
              const res = await fetch(data.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: buy.map((x) => ({ id: x.v, quantity: 1 })) }) });
              if (!res.ok) throw new Error(String(res.status));
              window.location.href = data.cart;
            } catch (e) {
              add.disabled = false;
              add.textContent = "L'ajout n'a pas marché, réessaie";
            }
          });
          card.appendChild(add);
          fix.appendChild(card);
        };
        draw();
      });
    });
  }
  cartmate();
  document.addEventListener('cart:update', () => window.setTimeout(cartmate, 400));
  let cmTick = 0;
  new MutationObserver(() => {
    if (cmTick) return;
    cmTick = window.requestAnimationFrame(() => { cmTick = 0; cartmate(); });
  }).observe(document.body, { childList: true, subtree: true });

  function openGuide(goal) {
    G = {};
    hist = [];
    R = { alt: {}, sizes: {}, sub: {}, off: {}, mode: null, safety: null, lesson: null, preset: false, pack: null, gift: null };
    if (goal === 'skate' || goal === 'outfit') {
      G.goal = goal;
      R.preset = true;
    }
    loadFeed();
    render();
    if (say) say.classList.remove('is-on');
    window.CaRoule.openSheet(guide);
  }

  document.addEventListener('click', (event) => {
    const a = event.target.closest('a[href$="#premier-skate"], a[href$="#mon-outfit"], [data-cr-guide]');
    if (!a) return;
    event.preventDefault();
    /* partout, la même entrée : « Mon skate / Mon outfit / Les deux » */
    openGuide('');
  });
  if (window.location.hash === '#premier-skate' || window.location.hash === '#mon-outfit') openGuide('');
})();

/* Histoire du shop : lecteur plein écran façon stories */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (root.dataset.crStoryReady) return;
    root.dataset.crStoryReady = '1';
    const player = root.querySelector('.cr-stories');
    if (!player) return;
    /* sortie vers <body> : le plein écran ne dépend pas des sections parentes */
    document.querySelectorAll('body > .cr-stories').forEach((old) => {
      if (old.id === player.id) old.remove();
    });
    document.body.appendChild(player);
    const slides = Array.from(player.querySelectorAll('.cr-st-slide'));
    const bars = Array.from(player.querySelectorAll('.cr-st-segs b'));
    const count = player.querySelector('.cr-st-count');
    const dur = (parseInt(root.dataset.duration || '5', 10) || 5) * 1000;
    let i = 0;
    let timer = null;
    let left = dur;
    let paused = false;
    let lastFocus = null;

    function run() {
      window.clearTimeout(timer);
      if (reduce || i >= slides.length - 1) {
        if (bars[i]) bars[i].style.transform = 'scaleX(1)';
        return;
      }
      const bar = bars[i];
      void bar.offsetWidth;
      bar.style.transition = 'transform ' + left + 'ms linear';
      bar.style.transform = 'scaleX(1)';
      timer = window.setTimeout(() => show(i + 1), left);
    }

    function show(n) {
      i = Math.max(0, Math.min(slides.length - 1, n));
      slides.forEach((s, j) => s.classList.toggle('is-on', j === i));
      bars.forEach((b, j) => {
        b.style.transition = 'none';
        b.style.transform = 'scaleX(' + (j < i ? 1 : 0) + ')';
      });
      const ch = slides[i].dataset.chapter;
      count.innerHTML = '';
      if (ch) {
        const em = document.createElement('em');
        em.textContent = ch;
        count.appendChild(em);
      }
      count.appendChild(document.createTextNode(i + 1 + ' / ' + slides.length));
      left = dur;
      paused = false;
      run();
    }

    function pause() {
      if (paused || reduce) return;
      paused = true;
      window.clearTimeout(timer);
      const bar = bars[i];
      const m = getComputedStyle(bar).transform;
      const sx = m && m !== 'none' ? parseFloat(m.split('(')[1]) : 0;
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(' + sx + ')';
      left = Math.max(200, dur * (1 - sx));
    }

    function resume() {
      if (!paused) return;
      paused = false;
      run();
    }

    function open(n) {
      lastFocus = document.activeElement;
      player.querySelectorAll('img[data-src]').forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
      player.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const buddy = document.getElementById('cr-buddy');
      if (buddy) buddy.hidden = true;
      show(n);
      player.querySelector('.cr-st-x').focus({ preventScroll: true });
    }

    function close() {
      window.clearTimeout(timer);
      player.hidden = true;
      document.documentElement.style.overflow = '';
      const buddy = document.getElementById('cr-buddy');
      if (buddy) buddy.hidden = false;
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }

    root.addEventListener('click', (e) => {
      const o = e.target.closest('[data-cr-story-open]');
      if (o) open(parseInt(o.getAttribute('data-cr-story-open'), 10) || 0);
    });
    player.addEventListener('click', (e) => {
      if (e.target.closest('[data-cr-story-close]')) close();
    });

    ['prev', 'next'].forEach((dir) => {
      const b = player.querySelector('[data-cr-story-' + dir + ']');
      let hold = null;
      let held = false;
      b.addEventListener('pointerdown', () => {
        held = false;
        hold = window.setTimeout(() => { held = true; pause(); }, 220);
      });
      b.addEventListener('pointerup', () => {
        window.clearTimeout(hold);
        if (held) { resume(); return; }
        show(i + (dir === 'next' ? 1 : -1));
      });
      b.addEventListener('pointerleave', () => {
        window.clearTimeout(hold);
        if (held) { held = false; resume(); }
      });
      b.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          show(i + (dir === 'next' ? 1 : -1));
        }
      });
    });

    document.addEventListener('keydown', (e) => {
      if (player.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(i + 1);
      else if (e.key === 'ArrowLeft') show(i - 1);
    });
  }

  const all = () => document.querySelectorAll('[data-cr-story]').forEach(init);
  all();
  document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
})();

/* Filtres en pilules : ouvrir le tiroir directement sur le filtre touché */
document.addEventListener('click', (event) => {
  const pill = event.target.closest('.cr-fpill[data-cr-facet]');
  if (!pill) return;
  const drawer = document.getElementById('filters-drawer');
  if (!drawer || typeof drawer.showDialog !== 'function') return;
  drawer.showDialog();
  const key = pill.getAttribute('data-cr-facet');
  window.requestAnimationFrame(() => {
    const items = drawer.querySelectorAll('accordion-custom[data-filter-param-name]');
    let target = null;
    items.forEach((item) => {
      const details = item.querySelector('details');
      if (!details) return;
      const match = item.getAttribute('data-filter-param-name') === key;
      details.open = match;
      if (match) target = details;
    });
    if (target) {
      target.scrollIntoView({ block: 'start' });
      const first = target.querySelector('input, button');
      if (first) first.focus({ preventScroll: true });
    }
  });
});


/* Pied de page : accordéons sur téléphone, colonnes ouvertes sur ordinateur */
(() => {
  const mq = window.matchMedia('(min-width: 750px)');
  const sync = () => {
    document.querySelectorAll('.cr-foot__col').forEach((d, i) => {
      if (d.tagName !== 'DETAILS') return;
      if (mq.matches) d.open = true;
      else if (!d.dataset.crTouched) d.open = i === 0;
    });
  };
  document.addEventListener('toggle', (e) => {
    if (e.target.classList && e.target.classList.contains('cr-foot__col') && !mq.matches) e.target.dataset.crTouched = '1';
  }, true);
  sync();
  document.addEventListener('DOMContentLoaded', sync);
  mq.addEventListener('change', sync);
})();

/* Descriptions produits : carte, titre en double retiré, « Clé : valeur » en tableau de specs */
(() => {
  const words = (s) => s.replace(/[^\p{L}\p{N}]+/gu, ' ').trim().toLowerCase().split(' ').filter(Boolean);
  function init() {
    const box = document.querySelector('.product-details rte-formatter');
    if (!box || box.classList.contains('cr-desc')) return;
    box.classList.add('cr-desc');
    const title = new Set(words((document.querySelector('h1.cr-vh') || {}).textContent || ''));
    const first = [...box.children].find((c) => c.textContent.trim());
    if (first && /^H[1-3]$/.test(first.tagName) && title.size) {
      const w = words(first.textContent);
      if (w.length && w.filter((x) => title.has(x)).length / w.length >= 0.75) first.remove();
    }
    box.querySelectorAll('li').forEach((li) => {
      if (li.querySelector('.cr-desc__k')) return;
      const m = li.textContent.replace(/\s+/g, ' ').match(/^\s*([^:]{2,40}?)\s*:\s*(.+)$/);
      if (!m) return;
      const k = document.createElement('span');
      k.className = 'cr-desc__k';
      k.textContent = m[1];
      const v = document.createElement('span');
      v.className = 'cr-desc__v';
      v.textContent = m[2].trim();
      li.replaceChildren(k, v);
      li.classList.add('cr-desc__row');
    });
  }
  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* Réseau mobile capricieux : une image du thème qui échoue est retentée une fois */
document.addEventListener(
  'error',
  (event) => {
    const img = event.target;
    if (!(img instanceof HTMLImageElement) || img.dataset.crRetry) return;
    if (!/\/assets\/caroule-/.test(img.currentSrc || img.src)) return;
    img.dataset.crRetry = '1';
    window.setTimeout(() => {
      const bust = (u) => u + (u.includes('?') ? '&' : '?') + 'r=1';
      if (img.srcset) img.srcset = img.srcset.split(', ').map((p) => { const [u, d] = p.split(' '); return bust(u) + ' ' + d; }).join(', ');
      img.src = bust(img.src);
    }, 1500);
  },
  true
);

/* « Skate & style » : onglets Côté skate / Côté style (téléphone) */
(() => {
  document.querySelectorAll('[data-cr-uni]').forEach((uni) => {
    const tabs = [...uni.querySelectorAll('[data-cr-uni-tab]')];
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.classList.toggle('is-on', on);
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        select(tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length], true);
      });
    });
  });
})();

/* Le jeu du versus (moteur unique)
   - data-mode="rounds" : un duel par catégorie ([{label, items}]), puis « Ta sélection » avec les gagnants.
   - data-mode="king" (défaut) : le gagnant reste, data-rounds manches, puis « Ton coup de cœur ».
   - un bouton [data-cr-duel-start] dans la boîte : le jeu ne démarre qu'au clic (duels repliés). */
(() => {
  const LINES = ['Choix sûr.', 'Ah ouais, carrément.', 'Bon goût, ça.', 'Rouli valide.', 'Serré, celui-là.', 'Le shop approuve.', 'Sans hésiter, hein ?'];
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const h = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
  const shuffle = (a) => { const b = a.slice(); for (let i = b.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [b[i], b[j]] = [b[j], b[i]]; } return b; };

  const money = (c) => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(c / 100);
  /* une phrase qui n'est pas sortie récemment (mémorisé sur le téléphone, d'une visite à l'autre) */
  function fresh(name, list) {
    let seen = [];
    try { seen = JSON.parse(localStorage.getItem('cr-said-' + name) || '[]'); } catch (e) {}
    const keep = Math.max(1, Math.floor(list.length * 0.6));
    let pool = list.map((x, i) => i).filter((i) => !seen.includes(i));
    if (!pool.length) pool = list.map((x, i) => i).filter((i) => i !== seen[seen.length - 1]);
    const i = pool[Math.floor(Math.random() * pool.length)];
    seen.push(i);
    try { localStorage.setItem('cr-said-' + name, JSON.stringify(seen.slice(-keep))); } catch (e) {}
    return list[i];
  }
  const VERDICT = [
    'T\u2019as du goût, toi.', 'Sélection validée par le shop.', 'Ça, c\u2019est un vestiaire de rider.', 'Rouli est fier de toi.',
    'Même le banc d\u2019essai applaudit.', 'Le mur de Dunk te salue bien bas.', 'On dirait la vitrine du samedi.', 'Propre. Rien à redire.',
    'T\u2019as l\u2019œil, ça se voit.', 'Le shop t\u2019embaucherait bien au rayon.',
  ];
  const SHY = [
    'Respire. Ça reste moins cher qu\u2019un poignet cassé.', 'On a vu pire. Et le montage est offert.', 'Promis, on ne le dira à personne.',
    'C\u2019est un investissement. Dans ton style.', 'Divisé par le nombre de sessions, c\u2019est donné.', 'Ton banquier ne lit pas ce site.',
    'Personne n\u2019a vu. Enfin, sauf moi.', 'Tu peux aussi n\u2019en prendre qu\u2019un. Je juge pas.',
  ];
  function titleFor(total, n) {
    const avg = n ? total / n : 0;
    if (avg >= 11000) return ['👑', 'Gros flex'];
    if (avg >= 7000) return ['🔥', 'Goût sûr'];
    return ['🧠', 'Malin du budget'];
  }

  /* confettis rose et cyan (rien si l'utilisateur réduit les animations) */
  function confetti(host) {
    if (reduce) return;
    const box = h('div', 'cr-confetti');
    box.setAttribute('aria-hidden', 'true');
    const colors = ['#ff4fb0', '#2fe3ff', '#fff6ee', '#b46bff', '#ffd23f'];
    for (let i = 0; i < 46; i++) {
      const c = h('i');
      c.style.left = Math.random() * 100 + '%';
      c.style.background = colors[i % colors.length];
      c.style.setProperty('--dx', (Math.random() * 160 - 80).toFixed(0) + 'px');
      c.style.setProperty('--r', (Math.random() * 720 - 360).toFixed(0) + 'deg');
      c.style.animationDelay = (Math.random() * 0.35).toFixed(2) + 's';
      c.style.width = c.style.height = (6 + Math.random() * 6).toFixed(0) + 'px';
      if (i % 3 === 0) c.style.borderRadius = '50%';
      box.appendChild(c);
    }
    host.appendChild(box);
    window.setTimeout(() => box.remove(), 2600);
  }

  /* Rouli débarque avec son verdict */
  function rouliSays(text, badge) {
    const w = h('div', 'cr-duel__rouli');
    const av = h('span', 'cr-duel__rav');
    const art = document.querySelector('.cr-rouli-art');
    if (art) av.innerHTML = art.outerHTML;
    const say = h('div', 'cr-duel__say');
    if (badge) say.appendChild(h('span', 'cr-duel__badge', badge[0] + ' ' + badge[1]));
    say.appendChild(h('p', '', text));
    w.append(av, say);
    return w;
  }

  /* le prix total, caché derrière un flou pour les timides */
  const HOT = [
    'Excellent choix. Celui-là, il a du caractère.', 'Je le savais. Il avait ta tête.', 'Celui-là, il te va déjà rien qu\u2019en photo.',
    'Bon flair. Tu veux le voir de plus près ?', 'Coup de foudre validé.', 'Lui, il a été fait pour toi.', 'Ah ouais, t\u2019as pas pris le plus timide.',
  ];
  const LOOK = [
    'OK, je me fais tout petit. 🤫', 'Prends ton temps, je surveille la planche.', 'Je bouge pas. Enfin, je roule pas.',
    'Je t\u2019attends au comptoir.', 'Regarde, touche, reviens. Je suis là.',
  ];

  /* « Alors, y en a un qui te chauffe vraiment ? » : coup de projecteur sur un produit */
  function hotOne(items) {
    const w = h('div', 'cr-duel__hot');
    const ask = () => {
      w.innerHTML = '';
      w.appendChild(rouliSays('Alors\u2026 y en a un qui te chauffe vraiment, ou je te laisse regarder tranquille ?', null));
      const row = h('div', 'cr-duel__choices');
      const yes = h('button', 'cr-duel__choice cr-duel__choice--hot', '🔥 Y en a un !');
      yes.type = 'button';
      const no = h('button', 'cr-duel__choice', '👀 Je regarde tranquille');
      no.type = 'button';
      yes.addEventListener('click', choose);
      no.addEventListener('click', () => { w.innerHTML = ''; w.appendChild(rouliSays(fresh('look', LOOK), null)); });
      row.append(yes, no);
      w.appendChild(row);
    };
    const choose = () => {
      w.innerHTML = '';
      w.appendChild(rouliSays('Montre-moi lequel. Je dirai rien.', null));
      const chips = h('div', 'cr-duel__chips');
      items.forEach((p) => {
        const c = h('button', 'cr-duel__chip');
        c.type = 'button';
        const img = document.createElement('img');
        img.src = p.img;
        img.alt = '';
        img.loading = 'lazy';
        c.append(img, h('span', '', p.cat || p.t));
        c.setAttribute('aria-label', p.t);
        c.addEventListener('click', () => spot(p));
        chips.appendChild(c);
      });
      w.appendChild(chips);
    };
    const spot = (p) => {
      const shy = w.closest('.cr-duel__shy');
      if (shy) shy.classList.add('is-spot');
      w.innerHTML = '';
      w.appendChild(rouliSays(fresh('hot', HOT), null));
      const card = h('div', 'cr-duel__spot');
      const img = document.createElement('img');
      img.src = p.img;
      img.alt = '';
      const m = h('div', 'cr-duel__spotmeta');
      if (p.cat) m.appendChild(h('span', 'cr-duel__pickcat', p.cat));
      m.append(h('b', '', p.t), h('span', 'cr-duel__price', p.p));
      card.append(img, m);
      w.appendChild(card);
      const btns = h('div', 'cr-duel__btns');
      if (p.one) {
        const add = h('button', 'cr-g-add', 'Ajouter au panier · ' + p.p);
        add.type = 'button';
        add.addEventListener('click', () => addOne(p, add, true));
        btns.appendChild(add);
        const see = document.createElement('a');
        see.className = 'cr-g-link';
        see.href = p.u;
        see.textContent = 'Voir la fiche →';
        btns.appendChild(see);
      } else {
        const see = document.createElement('a');
        see.className = 'cr-g-add';
        see.href = p.u;
        see.textContent = 'Choisir ma taille →';
        btns.appendChild(see);
      }
      const back = h('button', 'cr-g-link cr-g-link--mute', 'Un autre ?');
      back.type = 'button';
      back.addEventListener('click', choose);
      btns.appendChild(back);
      w.appendChild(btns);
    };
    ask();
    return w;
  }

  function shyPrice(items, onAddAll) {
    const total = items.reduce((t, p) => t + (p.c || 0), 0);
    const w = h('div', 'cr-duel__shy');
    const veil = h('button', 'cr-duel__peek');
    veil.type = 'button';
    veil.innerHTML = '<span class="cr-duel__blur">' + money(total) + '</span><span class="cr-duel__peeklabel">🙈 J\u2019ose regarder le prix</span>';
    veil.addEventListener('click', () => {
      veil.classList.add('is-open');
      veil.disabled = true;
      veil.querySelector('.cr-duel__peeklabel').textContent = '🫣 ' + fresh('shy', SHY);
      const addable = items.filter((p) => p.one);
      if (addable.length && onAddAll) {
        const all = h('button', 'cr-g-add cr-duel__addall', addable.length === items.length ? 'Tout ajouter au panier' : 'Ajouter les ' + addable.length + ' sans taille à choisir');
        all.type = 'button';
        all.addEventListener('click', () => onAddAll(addable, all));
        w.appendChild(all);
      }
      if (items.length > 1) w.appendChild(hotOne(items));
    });
    w.appendChild(veil);
    return w;
  }

  async function addMany(list, btn) {
    btn.disabled = true;
    btn.textContent = 'Ajout en cours…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list.map((p) => ({ id: p.v, quantity: 1 })) }) });
      if (!r.ok) throw new Error();
      btn.textContent = 'Dans le panier ✓';
      btn.classList.add('is-done');
    } catch (e) {
      btn.disabled = false;
      btn.textContent = 'Réessayer';
    }
  }

  function pickCard(p, onPick) {
    const b = h('button', 'cr-duel__card');
    b.type = 'button';
    b.setAttribute('aria-label', 'Je prends ' + p.t);
    const img = document.createElement('img');
    img.src = p.img;
    img.alt = '';
    img.loading = 'lazy';
    const m = h('span', 'cr-duel__meta');
    m.append(h('span', 'cr-duel__name', p.t), h('span', 'cr-duel__price', p.p));
    b.append(img, m);
    b.addEventListener('click', () => onPick(b));
    return b;
  }

  async function addOne(p, btn, label) {
    btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: p.v, quantity: 1 }] }) });
      if (!r.ok) throw new Error();
      btn.textContent = label ? 'Dans le panier ✓' : '✓';
      btn.classList.add('is-done');
    } catch (e) {
      btn.disabled = false;
      btn.textContent = label ? 'Réessayer' : '!';
    }
  }

  function game(box) {
    const stage = box.querySelector('[data-cr-duel-stage]');
    let raw = [];
    try { raw = JSON.parse(box.querySelector('[data-cr-duel-data]').textContent); } catch (e) {}
    const mode = box.dataset.mode || 'king';
    const rounds = mode === 'rounds' ? raw.filter((r) => r && r.items && r.items.length >= 2) : null;
    if (!stage || (mode === 'rounds' ? rounds.length < 2 : raw.length < 3)) { box.hidden = true; return null; }
    const total = mode === 'rounds' ? rounds.length : Math.min(parseInt(box.dataset.rounds, 10) || 8, raw.length - 1);
    let round;
    let champ;
    let pool;
    let picks;

    function bar(label, line) {
      const top = h('div', 'cr-duel__bar');
      top.append(h('span', 'cr-duel__round', label), h('span', 'cr-duel__line', line));
      const dots = h('span', 'cr-duel__dots');
      for (let i = 1; i <= total; i++) dots.appendChild(h('i', i < round ? 'on' : i === round ? 'now' : ''));
      top.appendChild(dots);
      return top;
    }

    function duel(a, b, label, line, onWin) {
      stage.innerHTML = '';
      const ring = h('div', 'cr-duel__ring');
      const go = (winner, el, other) => {
        el.classList.add('is-win');
        other.classList.add('is-lose');
        ring.classList.add('is-done');
        window.setTimeout(() => onWin(winner), reduce ? 120 : 420);
      };
      const ca = pickCard(a, (el) => go(a, el, cb));
      const cb = pickCard(b, (el) => go(b, el, ca));
      ring.append(ca, h('span', 'cr-duel__vs', 'VS'), cb);
      stage.append(bar(label, line), ring);
    }

    function next(line) {
      if (mode === 'rounds') {
        const r = rounds[round - 1];
        /* deux produits vraiment différents : pas deux coloris du même modèle (mêmes deux premiers mots) */
        const key = (p) => p.t.toLowerCase().split(/\s+/).slice(0, 2).join(' ');
        const mix = shuffle(r.items);
        const a = mix[0];
        const b = mix.slice(1).find((x) => key(x) !== key(a)) || mix[1];
        duel(a, b, r.label, 'Lequel tu préfères ?', (w) => {
          picks.push({ ...w, cat: r.label });
          if (round >= total) { selection(); return; }
          round += 1;
          next();
        });
      } else {
        const challenger = pool.shift();
        duel(champ, challenger, 'Manche ' + round + '/' + total, 'Lequel tu préfères ?', (w) => {
          champ = w;
          if (round >= total || !pool.length) { favourite(); return; }
          round += 1;
          next();
        });
      }
    }

    function replay() {
      const b = h('button', 'cr-g-link', 'Rejouer avec d’autres duels →');
      b.type = 'button';
      b.addEventListener('click', start);
      return b;
    }

    function selection() {
      stage.innerHTML = '';
      const res = h('div', 'cr-duel__result');
      const total = picks.reduce((t, p) => t + (p.c || 0), 0);
      res.append(h('p', 'cr-duel__crown', 'Ta sélection'), rouliSays(fresh('verdict', VERDICT), titleFor(total, picks.length)));
      const grid = h('ul', 'cr-duel__picks');
      picks.forEach((p) => {
        const li = h('li', 'cr-duel__pick');
        const a = document.createElement('a');
        a.href = p.u;
        const img = document.createElement('img');
        img.src = p.img;
        img.alt = '';
        img.loading = 'lazy';
        a.append(img, h('span', 'cr-duel__pickcat', p.cat), h('span', 'cr-duel__name', p.t), h('span', 'cr-duel__price', p.p));
        li.appendChild(a);
        if (p.one) {
          const add = h('button', 'cr-duel__add', '+');
          add.type = 'button';
          add.setAttribute('aria-label', 'Ajouter ' + p.t + ' au panier');
          add.addEventListener('click', () => addOne(p, add, false));
          li.appendChild(add);
        }
        grid.appendChild(li);
      });
      res.appendChild(grid);
      res.appendChild(shyPrice(picks, addMany));
      const btns = h('div', 'cr-duel__btns');
      btns.appendChild(replay());
      res.appendChild(btns);
      stage.appendChild(res);
      confetti(box);
      res.classList.add('is-in');
    }

    function favourite() {
      stage.innerHTML = '';
      const res = h('div', 'cr-duel__result');
      res.append(h('p', 'cr-duel__crown', 'Ton coup de cœur'), rouliSays(fresh('verdict', VERDICT), null));
      const a = document.createElement('a');
      a.href = champ.u;
      a.className = 'cr-duel__card cr-duel__card--win';
      const img = document.createElement('img');
      img.src = champ.img;
      img.alt = '';
      const m = h('span', 'cr-duel__meta');
      m.append(h('span', 'cr-duel__name', champ.t), h('span', 'cr-duel__price', champ.p));
      a.append(img, m);
      res.appendChild(a);
      const btns = h('div', 'cr-duel__btns');
      if (champ.one) {
        const add = h('button', 'cr-g-add', 'Ajouter au panier · ' + champ.p);
        add.type = 'button';
        add.addEventListener('click', () => addOne(champ, add, true));
        btns.appendChild(add);
      } else {
        const see = document.createElement('a');
        see.className = 'cr-g-add';
        see.href = champ.u;
        see.textContent = 'Choisir ma taille';
        btns.appendChild(see);
      }
      btns.appendChild(replay());
      res.appendChild(btns);
      stage.appendChild(res);
      confetti(box);
      res.classList.add('is-in');
    }

    function start() {
      round = 1;
      picks = [];
      if (mode !== 'rounds') {
        pool = shuffle(raw);
        champ = pool.shift();
      }
      next();
    }
    return start;
  }

  document.querySelectorAll('[data-cr-duel]').forEach((box) => {
    const start = game(box);
    if (!start) return;
    const trigger = box.querySelector('[data-cr-duel-start]');
    if (trigger) {
      trigger.addEventListener('click', () => {
        box.classList.add('is-open');
        trigger.hidden = true;
        start();
      });
    } else {
      start();
    }
  });
})();

/* Sélections qui changent à chaque visite : on tire au sort dans la réserve de chaque rangée */
(() => {
  document.querySelectorAll('ul[data-cr-shuffle]').forEach((ul) => {
    const tpl = ul.parentElement.querySelector('template[data-cr-pool]');
    if (!tpl) return;
    const pool = [...tpl.content.children];
    const n = parseInt(ul.dataset.show, 10) || pool.length;
    if (pool.length <= n) return;
    for (let i = pool.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [pool[i], pool[j]] = [pool[j], pool[i]];
    }
    const more = ul.querySelector('.cr-uni__card--more');
    ul.querySelectorAll('.cr-uni__card:not(.cr-uni__card--more)').forEach((li) => li.remove());
    pool.slice(0, n).forEach((li) => ul.insertBefore(li.cloneNode(true), more || null));
  });
})();
